/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneIcon32Regular = forwardRef('SendPaperplaneIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.33 5.896c-.501-2.286 1.9-4.113 3.97-3.02l20.238 10.692c1.954 1.033 1.954 3.831 0 4.864L8.3 29.123c-2.07 1.094-4.471-.733-3.97-3.02L6.54 16 4.33 5.896ZM8.37 17l-2.087 9.532a.75.75 0 0 0 1.083.823l20.238-10.692a.75.75 0 0 0 0-1.326L7.366 4.645a.75.75 0 0 0-1.083.824L8.369 15h7.753a1 1 0 1 1 0 2H8.37Z" })));
});
